import { createQueryKeys } from '@lukemorales/query-key-factory';

export const subscription = createQueryKeys('subscription', {
  /**
  Current user's subscription (GET /api/me/subscription)
  */
  me: null,
});
